const Positions = Object.freeze({
    CAFE_FOH: "cafe -foh",
    MANAGER: "manager",
    ADMIN: "admin",
    TEAM: "team",
});

export default Positions;